import { createFileRoute, redirect } from "@tanstack/react-router";
import { MedalsPage } from "../../components/participant/medals-page";
import { meProfileQuery } from "../../lib/api/me";

/** `/me/medals` — athletes only (an approved `Aa` card); anyone else goes to their profile. The API answers an empty list regardless. */
export const Route = createFileRoute("/_app/me/medals")({
	beforeLoad: async ({ context }) => {
		const profile = await context.queryClient.ensureQueryData(meProfileQuery);
		if (!profile.is_athlete) throw redirect({ to: "/me", replace: true });
	},
	component: MedalsPage,
});
